// extracted by mini-css-extract-plugin
export var imglyTypoButton = "style-module--imgly--typo-button--NUUzu";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--ovg2T";
export var imglyTypoH1 = "style-module--imgly--typo-h1--3xSND";
export var imglyTypoH2 = "style-module--imgly--typo-h2--10NGX";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--uwhMR";
export var imglyTypoH3 = "style-module--imgly--typo-h3--idzEU";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--TfS84";
export var imglyTypoH4 = "style-module--imgly--typo-h4--G8p4q";
export var imglyTypoH5 = "style-module--imgly--typo-h5--523XB";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--HB8Re";
export var imglyTypoIcon = "style-module--imgly--typo-icon--A1uhx";
export var imglyTypoLink = "style-module--imgly--typo-link--kT3ik";
export var imglyTypoOverline = "style-module--imgly--typo-overline--t2fn3";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--sGnj2";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--EuGxl";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--bPATB";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--SiUuu";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--d01gJ";
export var imglyTypoSubline = "style-module--imgly--typo-subline--LuNo5";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--Ps7dj";
export var naviLabelIsLarge = "style-module--navi-label-is-large--cdzNY";
export var naviLabelIsSmall = "style-module--navi-label-is-small--Cz6B5";
export var root = "style-module--root--uS-YM";
export var root__is_active = "style-module--root__is_active--1mcyG";
export var root__is_first = "style-module--root__is_first--gXLPE";
export var tab = "style-module--tab--l0Pus";
export var tab__is_active = "style-module--tab__is_active--Rn8z5";
export var tab__is_interactive = "style-module--tab__is_interactive--fFBFv";
export var tab__is_interactive_and_active = "style-module--tab__is_interactive_and_active--VKtIO";